// global
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Line } from 'react-chartjs-2';
import _ from 'lodash';
import { format, compareAsc } from 'date-fns';
//import DateFNSPT from 'date-fns/locale/pt';
// local
// views
import EmptyList from 'app/ui/commons/emptyList/EmptyList';
// lib
//import { diffBetweenDates, PRECISION } from 'app/lib/dateHelper';
//import { fromUTC } from 'app/lib/helper';

// css
import './TableOxigen.css';

const DATE_FORMAT = 'DD/MM/YYYY HH:mm:ss';

class GraficPrescrition extends Component {
    renderEmpty = () => <EmptyList emptyMessage="Nenhum histórico de consumo computado." />;
    renderGrafic(prescriptions, flows) {
        let labels = [];
        const pFlowDatas = {};
        const pPrescDatas = {};

        const options = {
            scales: {
                yAxes: [
                    {
                        ticks: {
                            mode: 'index',
                            beginAtZero: true,
                            steps: 1,
                            max: 15,
                        },
                    },
                ],
            },
        };

        for (let i in prescriptions) {
            const prescription = prescriptions[i];
            const sDate = format(new Date(prescription.date), DATE_FORMAT);
            labels.push(prescription.date);
            pPrescDatas[sDate] = prescription.prescription;
        }
        for (let x in flows) {
            const flow = flows[x];
            const sDate = format(new Date(flow.date), DATE_FORMAT);
            labels.push(flow.date);
            pFlowDatas[sDate] = flow.flow;
        }

        labels = labels.sort((a, b) => {
            return compareAsc(a, b);
        });

        let repeatFlow = 0;
        let repeatPresc = 0;
        let flowDatas = [];
        let prescDatas = [];

        for (let y in labels) {
            const label = format(labels[y], DATE_FORMAT);
            if (label in pPrescDatas) {
                repeatPresc = pPrescDatas[label];
            }
            if (label in pFlowDatas) {
                repeatFlow = pFlowDatas[label];
            }
            prescDatas.push(repeatPresc);
            flowDatas.push(repeatFlow);
            labels[y] = label;
        }

        prescDatas = prescDatas.slice(-flows.length);
        flowDatas = flowDatas.slice(-flows.length);
        labels = labels.slice(-flows.length);

        const dataSet = {
            labels,
            datasets: [
                {
                    label: 'Prescrição',
                    data: prescDatas,
                    fill: false,
                    backgroundColor: '#3C9A50',
                    borderColor: '#3C9A50',
                    borderCapStyle: 'butt',
                },
                {
                    label: 'Consumo',
                    data: flowDatas,
                    fill: false,
                    backgroundColor: 'red',
                    borderColor: 'red',
                    borderCapStyle: 'butt',
                },
            ],
        };

        return <Line data={dataSet} width={900} height={290} options={options} />;
    }
    render() {
        const { data, flows } = this.props;
        return _.isEmpty(data) ? this.renderEmpty() : this.renderGrafic(data, flows);
    }
}

GraficPrescrition.propTypes = {
    data: PropTypes.array,
    flows: PropTypes.array,
};

export default GraficPrescrition;
